module.exports = __webpack_public_path__ + "05acfdb5.woff";